/**
 * Motivo (select com as categorias do backend) e comentário livre. O
 * cancelamento da assinatura e o "Excluir conta" usam listas de motivos
 * próprias (chamado 7116).
 */
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Textarea } from '@/components/ui/textarea';

const LIMITE_DO_COMENTARIO = 1000;

export interface ReasonOption<T extends string> {
  value: T;
  label: string;
}

interface ReasonFieldsProps<T extends string> {
  reasonLabel: string;
  options: ReadonlyArray<ReasonOption<T>>;
  reason: T | '';
  onReasonChange: (reason: T) => void;
  comment: string;
  onCommentChange: (comment: string) => void;
}

export function ReasonFields<T extends string>({
  reasonLabel,
  options,
  reason,
  onReasonChange,
  comment,
  onCommentChange,
}: Readonly<ReasonFieldsProps<T>>) {
  return (
    <div className="space-y-4 py-1">
      <div className="space-y-2">
        <Label id="cancelReasonCategoryLabel" className="text-sm">
          {reasonLabel}
        </Label>
        <Select value={reason} onValueChange={(valor) => onReasonChange(valor as T)}>
          <SelectTrigger aria-labelledby="cancelReasonCategoryLabel">
            <SelectValue placeholder="Selecione um motivo" />
          </SelectTrigger>
          {/* No celular a lista não passa da largura do campo: as opções quebram linha. */}
          <SelectContent className="max-w-[var(--radix-select-trigger-width)]">
            {options.map((opcao) => (
              <SelectItem key={opcao.value} value={opcao.value} className="whitespace-normal">
                {opcao.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-2">
        <Label htmlFor="cancelReasonComment" className="text-sm">
          Conte mais (opcional)
        </Label>
        <Textarea
          id="cancelReasonComment"
          value={comment}
          onChange={(e) => onCommentChange(e.target.value.slice(0, LIMITE_DO_COMENTARIO))}
          placeholder="Sua opinião nos ajuda a melhorar."
          maxLength={LIMITE_DO_COMENTARIO}
          rows={3}
        />
      </div>
    </div>
  );
}
